import { render, staticRenderFns } from "./CollegeConstitution.vue?vue&type=template&id=3471e7d9&scoped=true&"
import script from "./CollegeConstitution.vue?vue&type=script&lang=js&"
export * from "./CollegeConstitution.vue?vue&type=script&lang=js&"
import style0 from "./CollegeConstitution.vue?vue&type=style&index=0&id=3471e7d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3471e7d9",
  null
  
)

export default component.exports